import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _createForOfIteratorHelper from "@babel/runtime-corejs2/helpers/esm/createForOfIteratorHelper";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/esm/createSuper";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { RecaptchaServiceInterface } from '@central-products/interface-recaptcha-service';
import { loadScript as _loadScript } from '@central-products/script-module-loader';
import './index.scss';
export var RecaptchaService = /*#__PURE__*/function (_RecaptchaServiceInte) {
  _inherits(RecaptchaService, _RecaptchaServiceInte);

  var _super = _createSuper(RecaptchaService);

  function RecaptchaService(config) {
    var _this;

    _classCallCheck(this, RecaptchaService);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "config", void 0);

    _defineProperty(_assertThisInitialized(_this), "loadScriptPromise", void 0);

    _this.config = config;
    return _this;
  }

  _createClass(RecaptchaService, [{
    key: "init",
    value: function init() {
      this.loadScript();
    }
  }, {
    key: "invoke",
    value: function () {
      var _invoke = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new _Promise( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
                    var executeTimer;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            executeTimer = window.setTimeout(function () {
                              resolve({
                                response: undefined
                              });
                            }, payload.timeout);
                            _context2.next = 4;
                            return _this2.loadScript();

                          case 4:
                            if (!(!window.grecaptcha || !window.grecaptcha.enterprise || !window.grecaptcha.enterprise.ready)) {
                              _context2.next = 7;
                              break;
                            }

                            resolve({
                              response: undefined
                            });
                            return _context2.abrupt("return");

                          case 7:
                            window.grecaptcha.enterprise.ready( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                              var invokeFunction, _iterator, _step, path, response;

                              return _regeneratorRuntime.wrap(function _callee$(_context) {
                                while (1) {
                                  switch (_context.prev = _context.next) {
                                    case 0:
                                      _context.prev = 0;
                                      invokeFunction = window.grecaptcha.enterprise;
                                      _iterator = _createForOfIteratorHelper(payload.function.split('.'));
                                      _context.prev = 3;

                                      _iterator.s();

                                    case 5:
                                      if ((_step = _iterator.n()).done) {
                                        _context.next = 13;
                                        break;
                                      }

                                      path = _step.value;
                                      // @ts-ignore
                                      invokeFunction = invokeFunction[path];

                                      if (!(typeof invokeFunction === 'undefined')) {
                                        _context.next = 11;
                                        break;
                                      }

                                      resolve({
                                        response: undefined
                                      });
                                      return _context.abrupt("return");

                                    case 11:
                                      _context.next = 5;
                                      break;

                                    case 13:
                                      _context.next = 18;
                                      break;

                                    case 15:
                                      _context.prev = 15;
                                      _context.t0 = _context["catch"](3);

                                      _iterator.e(_context.t0);

                                    case 18:
                                      _context.prev = 18;

                                      _iterator.f();

                                      return _context.finish(18);

                                    case 21:
                                      _context.next = 23;
                                      return invokeFunction(_this2.config.siteKey, payload.options);

                                    case 23:
                                      response = _context.sent;
                                      window.clearTimeout(executeTimer);
                                      resolve({
                                        response: response
                                      });
                                      _context.next = 31;
                                      break;

                                    case 28:
                                      _context.prev = 28;
                                      _context.t1 = _context["catch"](0);
                                      resolve({
                                        response: undefined
                                      });

                                    case 31:
                                    case "end":
                                      return _context.stop();
                                  }
                                }
                              }, _callee, null, [[0, 28], [3, 15, 18, 21]]);
                            })));
                            _context2.next = 13;
                            break;

                          case 10:
                            _context2.prev = 10;
                            _context2.t0 = _context2["catch"](0);
                            resolve({
                              response: undefined
                            });

                          case 13:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, null, [[0, 10]]);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function invoke(_x) {
        return _invoke.apply(this, arguments);
      }

      return invoke;
    }()
  }, {
    key: "loadScript",
    value: function () {
      var _loadScript2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!this.loadScriptPromise) {
                  this.loadScriptPromise = new _Promise( /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(resolve) {
                      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _context4.prev = 0;
                              _context4.next = 3;
                              return _loadScript({
                                name: 'recaptcha-enterprise',
                                src: "https://www.google.com/recaptcha/enterprise.js?render=".concat(_this3.config.siteKey)
                              });

                            case 3:
                              _context4.next = 7;
                              break;

                            case 5:
                              _context4.prev = 5;
                              _context4.t0 = _context4["catch"](0);

                            case 7:
                              resolve();

                            case 8:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4, null, [[0, 5]]);
                    }));

                    return function (_x3) {
                      return _ref3.apply(this, arguments);
                    };
                  }());
                }

                return _context5.abrupt("return", this.loadScriptPromise);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function loadScript() {
        return _loadScript2.apply(this, arguments);
      }

      return loadScript;
    }()
  }]);

  return RecaptchaService;
}(RecaptchaServiceInterface);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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